import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      minWidth: '100%',
      margin: 0,
    },
    paper: {
      boxShadow: '0px 3px 6px #0000001A',
      textAlign: 'center',
      padding: '0',
    },
    tabContent: {},
    customRootClass: {
      boxShadow: 'none',
    },
    tab: {
      padding: '25px 35px 20px',
    },
    description: {
      lineHeight: 1,
      marginTop: 25,
      marginBottom: 15,
    },
    stepperContainer: {
      margin: '0 auto',
      maxWidth: 700,
    },
    textContainer: {
      padding: '24px 32px',
    },
    textContainerDetails: {
      padding: '10px 32px',
    },
    nextButton: {
      textTransform: 'capitalize',
    },
    providerInfo: {
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
      paddingBottom: theme.spacing(1),
    },
    editButton: {
      fontWeight: 500,
      textTransform: 'capitalize',
    },
    statusTooltip: {
      marginLeft: 3,
      fontSize: 16,
    },
    rowForm: {
      marginTop: 20,
      marginBottom: 20,
    },
    selectField: {
      width: '100%',
    },
    mfaCheckbox: {
      paddingLeft: 0,
    },
    mfaDescriptionList: {
      listStyleType: 'disc',
      paddingLeft: 24,
    },
    mfaDescriptionListItem: {
      display: 'list-item',
    },
    note: {
      border: `1px dashed ${theme.palette.warning.main}`,
      padding: theme.spacing(1),
      borderRadius: theme.shape.borderRadius,
    },
  };
});

export default useStyles;
